export default __webpack_public_path__ + "main-person.png";